import React from "react";

import styles from "../../assets/styles/Onboarding/Onboarding.module.scss";
import { businessStore, userStore } from "../../stores";
import OnboardLeft from "./OnboardLeft";
import StageTwo from "./StageTwo";

const OnboardingStageOne = ({
	validationSchema,
	onSubmit,
	loading
}) => {
  return (
    <div className={styles.container}>
      <OnboardLeft
        crumbs1={styles.crumbs__default}
        crumbs2={styles.crumbs__default}
        crumbs3={styles.crumbs__active}
      />
      <div className={styles.right}>
        <h4
          className={`${styles.text__center} ${styles.text__color__primary} ${styles.text__subtitle} ${styles.mb_10}`}
        >
          {userStore.user.business.tradingName},
          <br />
          We are almost there
        </h4>
        <StageTwo
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        loading={loading}
         />
      </div>
    </div>
  );
};

export default OnboardingStageOne;
